import styled from "@emotion/styled";
import { Colors } from "@snapchat/snap-design-system";

export const PageSubHeader = styled.p`
    width: 100%;
    margin: 0;
    padding-top: 4px;

    font-size: 16px;
    font-weight: 500;
    line-height: 20px;
    color: ${Colors.Gray.V300};
`;
